import React from 'react';
import { AlertTriangleIcon, ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { scarcity } from '../data/content';
interface CountdownPanelProps {
  showScarcity?: boolean;
}
export function CountdownPanel({
  showScarcity = true
}: CountdownPanelProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  const taken = scarcity.total - scarcity.left;
  const takenPercent = Math.round(taken / scarcity.total * 100);
  return <div className="mx-auto w-full max-w-narrow text-center" data-id="element-48" data-mp="c6qzgd27jlq8">
      <p className="inline-flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.16em] text-blue-700 md:text-base" data-id="element-49" data-mp="h52d6yvmigdq">
        <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-50" data-mp="26l1pgoujglxl" />
        Oferta de lanzamiento — cierra en:
      </p>

      <div className="mt-6 flex items-start justify-center gap-4 md:gap-8" role="timer" data-id="element-51" data-mp="2bil5nuasr8s6">
        {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-52" data-mp="1lf3wwmz0laae">
            <span className="font-display text-5xl font-extrabold tabular-nums leading-none tracking-tight text-blue-600 md:text-7xl" data-id="element-53" data-mp="1hf3l7a3avd71">
              {unit.value}
            </span>
            <span className="mt-2 text-xs font-bold uppercase tracking-[0.2em] text-blue-900/55" data-id="element-54" data-mp="1q8ye9jr5dd6b">
              {unit.label}
            </span>
          </div>)}
      </div>

      {showScarcity && <div className="mt-8" data-id="element-55" data-mp="yi2d3geg8wyv">
          <p className="inline-flex items-center gap-2 rounded-xl bg-alert-50 px-4 py-2.5 text-sm font-semibold text-alert-600 ring-1 ring-alert-100 md:text-base" data-id="element-56" data-mp="yiu042tzdmdj">
            <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-57" data-mp="17gns51kpptuw" />
            Cuando se agoten los cupos sube a {scarcity.nextPrice}.
          </p>

          <div className="mt-7" data-id="element-58" data-mp="2iwksrn1wy27y">
            <div className="flex items-baseline justify-between text-sm font-semibold text-blue-900/70" data-id="element-59" data-mp="2ivj5mk7mhp9v">
              <span data-id="element-60" data-mp="2qw8qyx3ogn7c">Cupos al precio de lanzamiento</span>
              <span data-id="element-61" data-mp="2uyvjl086ac5l">
                {scarcity.left} de {scarcity.total}
              </span>
            </div>
            <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-blue-100" data-id="element-62" data-mp="2zy895sqfhxbv">
              <div className="h-full rounded-full bg-blue-600" style={{
            width: `${takenPercent}%`
          }} data-id="element-63" data-mp="34x1ntohgbudm" />
            </div>
            <p className="mt-2 text-right text-xs text-blue-900/55" data-id="element-64" data-mp="27b481yugi35d">
              {taken} cupos ya tomados — {scarcity.note}
            </p>
          </div>
        </div>}
    </div>;
}